import React from 'react';
import PropTypes from 'prop-types';
import phrasesType from '../proptypes/phrases';

const NoScores = ({ phrases: { noScoresMessage, noScoresInstruction }, link }) => (
  <div className="no-scores col-12">
    <p>{noScoresMessage}</p>
    <br />
    <p>
      <a className="btn btn-secondary" href={link}>
        {noScoresInstruction}
      </a>
    </p>
  </div>
);

NoScores.propTypes = {
  phrases: phrasesType.isRequired,
  link: PropTypes.string.isRequired,
};

export default NoScores;
